import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "19",
  height: "20",
  viewBox: "0 0 19 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g id=\"Layer_1\" clip-path=\"url(#clip0_2940_176425)\"><path id=\"Vector\" d=\"M18.4375 17.4004H0V19.4004H18.4375V17.4004Z\" fill=\"#AA1E2D\"></path><path id=\"Vector_2\" d=\"M18.4209 6.62939L17.0068 5.21533L10.2207 12.0019V0H8.2207V12.002L1.43359 5.21533L0.0195312 6.62939L9.2207 15.8301L18.4209 6.62939Z\" fill=\"#AA1E2D\"></path></g><defs><clipPath id=\"clip0_2940_176425\"><rect width=\"18.4375\" height=\"19.4009\" fill=\"white\"></rect></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }